import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import api from '../api/axios';
import { useAuth } from '../context/AuthContext';
import { useToast } from '../components/Toast';
import BrandLogo from '../components/BrandLogo';

const AcceptInvite = () => {
  const [params] = useSearchParams();
  const token = params.get('token');
  const navigate = useNavigate();
  const toast = useToast();
  const { saveSession } = useAuth();
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    if (!token) {
      setError('Invalid invitation link');
      setLoading(false);
      return;
    }
    api.get(`/auth/invite/${token}`)
      .then((r) => setProfile(r.data))
      .catch((err) => {
        setError(err.response?.data?.message || 'Invitation link is invalid or expired');
      })
      .finally(() => setLoading(false));
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 6) {
      toast('Password must be at least 6 characters', 'error');
      return;
    }
    if (password !== confirm) {
      toast('Passwords do not match', 'error');
      return;
    }
    setSubmitting(true);
    try {
      const { data } = await api.post(`/auth/invite/${token}`, { password });
      saveSession(data.user);
      toast('Password created! Welcome to Tychi Desk.', 'success');
      navigate('/dashboard');
    } catch (err) {
      toast(err.response?.data?.message || 'Failed to set password', 'error');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="login-screen">
      <div className="login-glow" />
      <div className="login-card">
        <div className="login-logo login-logo--full">
          <BrandLogo variant="full" className="login-brand-logo login-brand-logo--card" />
        </div>
        <h2 className="login-title">Create your password</h2>
        {loading ? (
          <p className="login-sub">Verifying invitation…</p>
        ) : error ? (
          <>
            <p className="login-sub" style={{ color: 'var(--red)' }}>{error}</p>
            <p style={{ marginTop: 16, fontSize: 13, textAlign: 'center' }}>
              <Link to="/login" style={{ color: '#60a5fa' }}>Back to login</Link>
            </p>
          </>
        ) : (
          <>
            <p className="login-sub">
              Hi {profile?.name}, set a password for <strong>{profile?.email}</strong> to access the portal.
            </p>
            <form onSubmit={submit}>
              <div className="form-group">
                <label>New password</label>
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="At least 6 characters"
                  required
                  minLength={6}
                />
              </div>
              <div className="form-group">
                <label>Confirm password</label>
                <input
                  type="password"
                  value={confirm}
                  onChange={(e) => setConfirm(e.target.value)}
                  placeholder="Re-enter password"
                  required
                  minLength={6}
                />
              </div>
              <button className="btn btn-primary login-btn" type="submit" disabled={submitting}>
                {submitting ? 'Saving…' : 'Create password & sign in'}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
};

export default AcceptInvite;
